import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { cookie } from '@ifeng-fe/ui_base';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { rel } from '../../../utils/rel';

class SubNav extends React.PureComponent {
    static propTypes = {
        subNavArea: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { subNavArea } = this.props;

        const len = subNavArea.length;

        return (
            <div id="subNav" className={styles.sub_box}>
                <ul className={styles.sub_nav}>
                    {subNavArea.map((item, index) => (
                        <li key={index} style={{ width: `${99 / len}%` }}>
                            <a href={item.url} rel={rel} title={item.title}>
                                {item.title}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(SubNav);
